import { useState } from 'react';
import { ViewType } from '../types';

interface UseTimelineMouseTrackingProps {
  dates: Array<{ date: string }>;
  spacing: number;
  viewType: ViewType;
}

interface MousePosition {
  x: number;
  date: string;
}

export const useTimelineMouseTracking = ({ dates, spacing, viewType }: UseTimelineMouseTrackingProps) => {
  const [isMouseInTimeline, setIsMouseInTimeline] = useState(false);
  const [mousePosition, setMousePosition] = useState<MousePosition | null>(null);

  const getTopPosition = () => {
    switch (viewType) {
      case 'weekly':
        return 77.5;
      case 'quarterly':
        return 103.5
      case 'yearly':
        return 68.5;
      default:
        return 67.5;
    }
  };

  const handleTimelineMouseMove = (e: React.MouseEvent) => {
    if (!dates.length) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    
    // Clamp x to timeline bounds for smoother experience
    const clampedX = Math.max(0, Math.min(x, dates.length * spacing));
    
    // Find which date section the mouse is over
    const sectionIndex = Math.floor(clampedX / spacing);
    const boundedIndex = Math.max(0, Math.min(sectionIndex, dates.length - 1));
    
    const date = dates[boundedIndex];
    
    // Update position immediately for maximum smoothness
    setMousePosition({ x: clampedX, date: date.date });
    if (!isMouseInTimeline) {
      setIsMouseInTimeline(true);
    }
  };

  const handleTimelineMouseEnter = () => {
    setIsMouseInTimeline(true);
  };

  const handleTimelineMouseLeave = () => {
    setIsMouseInTimeline(false);
    setMousePosition(null);
  };

  const mouseHandlers = {
    onMouseMove: handleTimelineMouseMove,
    onMouseEnter: handleTimelineMouseEnter,
    onMouseLeave: handleTimelineMouseLeave,
  };

  return {
    isMouseInTimeline,
    mousePosition,
    topPosition: getTopPosition(),
    mouseHandlers,
  };
}; 